import * as XLSX from 'xlsx';

const generateAndDownloadExcelFile = (data: string[][]): void => {
  // Create a new workbook and a worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  // Generate a binary string representation of the workbook
  const binaryString = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'binary',
  });

  // Convert the binary string to an ArrayBuffer
  const buffer = new ArrayBuffer(binaryString.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < binaryString.length; i++) {
    view[i] = binaryString.charCodeAt(i) & 0xff;
  }

  // Create a Blob from the ArrayBuffer
  const blob = new Blob([buffer], { type: 'application/octet-stream' });

  // Create a link element and trigger the download
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'data.xlsx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default generateAndDownloadExcelFile;
